module.exports = __webpack_public_path__ + "static/media/notification-bell.3586bcc3.svg";